import {useAuth} from '_component/modules/auth'
import {PageLink, PageTitle} from '_metronic/layout/core'
import {ReactNode, useEffect} from 'react'
import {useSelector} from 'react-redux'
import {Navigate, Outlet, Route, Routes, useNavigate} from 'react-router-dom'
import DevToolsNav, {DEV_TOOLS} from './component/DevToolsNav'
import NoticeConfigPage from './component/NoticeConfigPage'
import PhotoConfigPage from './component/PhotoConfigPage'
import ServerCycleConfigPage from './component/ServerCycleConfigPage'
import SignalConfigPage from './component/SignalConfigPage'

const profileBreadCrumbs: Array<PageLink> = [
  {title: '운영 도구', path: '/dev', isSeparator: false, isActive: false},
  {title: '', path: '', isSeparator: true, isActive: false},
]

/** 경로별 화면. 탭 순서와 제목은 DEV_TOOLS 가 들고 있다. */
const toolElements: Record<string, ReactNode> = {
  'signal-config': <SignalConfigPage />,
  'notice-config': <NoticeConfigPage />,
  'server-cycle-config': <ServerCycleConfigPage />,
  'photo-config': <PhotoConfigPage />,
}

/** 도구가 늘어나도 탭이 계속 보이도록 화면 위쪽에 고정한다 */
const DevToolsLayout = () => (
  <>
    <DevToolsNav />
    <Outlet />
  </>
)

/**
 * 운영자 전용 도구 모음.
 *
 * 사이드 메뉴에 노출하지 않고 URL 로만 접근한다(`/dev/signal-config`).
 * 메뉴에 없다고 해서 미사용 페이지가 아니므로 정리 대상으로 오해하지 말 것.
 * 대신 도구끼리는 상단 탭으로 오갈 수 있다.
 */
const DevToolsPage = () => {
  const {logout} = useAuth()
  const navigate = useNavigate()
  const userInfo = useSelector((state: any) => state.userInfo?.userInfo)

  /* 주소를 숨기는 것은 편의일 뿐이라 계정 확인을 별도로 둔다 */
  useEffect(() => {
    if (userInfo === null || !String(userInfo?.accountType ?? '').includes('sys')) {
      navigate('/auth')
      logout()
    }
  }, [])

  return (
    <Routes>
      <Route element={<DevToolsLayout />}>
        {DEV_TOOLS.map((tool) => (
          <Route
            key={tool.path}
            path={tool.path}
            element={
              <>
                <PageTitle breadcrumbs={profileBreadCrumbs}>{tool.title}</PageTitle>
                {toolElements[tool.path]}
              </>
            }
          />
        ))}
        <Route index element={<Navigate to={DEV_TOOLS[0].path} replace />} />
      </Route>
    </Routes>
  )
}

export default DevToolsPage
